(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TempSector', TempSector);

    TempSector.$inject = ['$resource', 'DateUtils'];

    function TempSector ($resource, DateUtils) {
        var resourceUrl =  'api/temp-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issuedDate = DateUtils.convertDateTimeFromServer(data.issuedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
